import { render, staticRenderFns } from "./custom-form-common-service.vue?vue&type=template&id=4f503afc&"
import script from "./custom-form-common-service.vue?vue&type=script&lang=js&"
export * from "./custom-form-common-service.vue?vue&type=script&lang=js&"
import style0 from "./custom-form-common-service.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports